import { NgModule } from '@angular/core';
import { DocumentHistoryPlugin } from './plugins/document-history/document-history.plugin';
import { DocumentRelationPlugin } from './plugins/document-relation/document-relation.plugin';
import { ImageRelationPlugin } from './plugins/image-relation/image-relation.plugin';
import { SupportModule } from '../support/support.module';
import { FileUploadModule } from 'ng2-file-upload';
import { FormsModule } from '../forms/forms.module';
import { LightboxModule } from 'ngx-lightbox';
import { ImageComponent } from '@kaiser-software/chassis-core/src/app/files/components/image/image.component';

@NgModule({
    imports: [SupportModule, FileUploadModule, FormsModule, LightboxModule],
    exports: [ImageComponent],
    declarations: [DocumentHistoryPlugin, DocumentRelationPlugin, ImageRelationPlugin, ImageComponent],
    entryComponents: [DocumentHistoryPlugin, DocumentRelationPlugin, ImageRelationPlugin],
    providers: [],
})
export class FilesModule {
}



// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/files/files.module.ts